var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wait-screen"},[_c('StepHeader',[_c('h1',[_vm._v("Personalizing Your Offer")])]),_c('WaitScreenLoadingBar',{attrs:{"visible":_vm.loadingBarVisible}}),_c('WaitScreenAnimation',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
      callback: _vm.animationVisibilityChanged,
      intersection: {
        threshold: 0.25
      },
    }),expression:"{\n      callback: animationVisibilityChanged,\n      intersection: {\n        threshold: 0.25\n      },\n    }"}]}),_c('WaitScreenAwards'),_c('WaitScreenReviews')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }